import axios from 'axios';
import {getGlobalState, setGlobalState} from './globalState';
import config from '../config/config.json';

const apiBaseUrl = config.apiBaseUrl;
const allTreeUserId = config.allTreeUserId;

function fillTemplate(template, values) {
    return template.replace(/\[\[(\w+)\]\]/g, (_, key) => values[key] || '');
}

export const processOutgoing = (id) => {
  if (typeof id === 'string') {
      if (id.startsWith('d_') || id.startsWith('f_')) {
          return id.substring(2);
      } else {
          return id;
      }
  } else {
        return id;
  }
};

export const postUserInfo = async (user) => {
    try {
        const response = await axios.post(`${apiBaseUrl}/getUserInfo/`, {
            myUserEmail: user.email,
            myName: user.name,
            myGivenName: user.given_name,
            action: 'getUserInfo'
        });
        // console.log('User info response:', response.data);
        const { user_id, is_owner, is_admin, my_folder_id, is_new_left_nav, is_new_top_nav } = response.data[0];
        setGlobalState({
            myUserId: user_id,
            isOwner: is_owner,
            isAdmin: is_admin,
            myFolderId: my_folder_id,
            isNewLeftNav: is_new_left_nav,
            isNewTopNav: is_new_top_nav
        });
        console.log("User info set in global state:", response.data[0]);

        await myTreeData();
        await allTreeData();
        await getPromoData();
        await getReccoData();

        return response.data;
    } catch (error) {
        console.error('Error posting user info:', error);
        throw error;
    }
};

export const myTreeData = async () => {
    try {
        const { myUserId } = getGlobalState();
        const response = await axios.post(`${apiBaseUrl}/getTreeData`, {
            userId: myUserId,
            runningUserId: myUserId,
            action: 'myTreeData'
        });

        setGlobalState({ myTreeData: response.data });
        return response.data;
    } catch (error) {
        console.error('Error fetching my tree data:', error);
        throw error;
    }
};

export const allTreeData = async () => {
    try {
        const { myUserId } = getGlobalState();
        const response = await axios.post(`${apiBaseUrl}/getTreeData`, {
            userId: allTreeUserId,
            runningUserId: myUserId,
            action: 'allTreeData'
        });
        setGlobalState({ allTreeData: response.data });
        return response.data;
    } catch (error) {
        console.error('Error fetching all tree data:', error);
        throw error;
    }
};

export const deleteUserDashboard = async (dashboardId, folderId) => {
    try {
        const { myUserId } = getGlobalState();
        console.log('deleteUserDashboard:', dashboardId);
        const response = await axios.post(`${apiBaseUrl}/deleteUserDashboard/`, {
            myUserId: myUserId,
            action: 'deleteUserDashboard',
            folderId: folderId,
            dashboardId: dashboardId
        });
        console.log('deleteUserDashboard response:', response.data);
    } catch (error) {
        console.error('Error deleting user dashboard:', error);
        throw error;
    }

};

export const setNewLeftNav = async () => {
    try {
        const { myUserId } = getGlobalState();
        const response = await axios.post(`${apiBaseUrl}/setNewLeftNav/`, {
            myUserId: myUserId,
            action: 'setNewLeftNav'
        });
    } catch (error) {
        console.error('Error setting new left nav:', error);
        throw error;
    }
};

export const setNewTopNav = async () => {
    try {
        const { myUserId } = getGlobalState();
        const response = await axios.post(`${apiBaseUrl}/setNewTopNav/`, {
            myUserId: myUserId,
            action: 'setNewTopNav'
        });
    } catch (error) {
        console.error('Error setting new top nav:', error);
        throw error;
    }
};

export const deleteUserFolder = async (folderId) => {
    try {
        const { myUserId } = getGlobalState();
        const response = await axios.post(`${apiBaseUrl}/deleteUserFolder`, {
            myUserId,
            folderId,
            action: 'deleteUserFolder'
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting folder:', error);
        throw error;
    }
};

export const getPromoData = async () => {
    try {
        const { myUserId } = getGlobalState();
        const response = await axios.post(`${apiBaseUrl}/getPromoData`, {
            myUserId,
            action: 'getPromoData'
        });
        setGlobalState({ promoData: response.data });
        return response.data;
    } catch (error) {
        console.error('Error fetching promo data:', error);
        throw error;
    }
};

export const getReccoData = async () => {
    try {
        const { myUserId } = getGlobalState();
        const response = await axios.post(`${apiBaseUrl}/getReccoData`, {
            myUserId,
            action: 'getReccoData'
        });
        setGlobalState({ reccoData: response.data });
        return response.data;
    } catch (error) {
        console.error('Error fetching recco data:', error);
        throw error;
    }
};

export const getTargetsForDeprecation = async (userId) => {
    const myUserId = getGlobalState().myUserId;
    try {
        const response = await axios.post(`${apiBaseUrl}/getTargetsForDeprecation`, {
            userId: userId,
            runningUserId: myUserId,
            action: 'getTargetsForDeprecation'
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching targets for deprecation:', error);
        throw error;
    }
};

export const getOwnerDashboardsForPublishing = async (userId) => {
    try {
        const response = await axios.post(`${apiBaseUrl}/getOwnerDashboardsForPublishing`, {
            myUserId: userId,
            action: 'getOwnerDashboardsForPublishing'
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching targets for deprecation:', error);
        throw error;
    }
};

export const getDashboardViewsByDate = async (userId) => {
    try {
        const response = await axios.post(`${apiBaseUrl}/getDashboardViewsByDate`, {
            myUserId: userId,
            action: 'getDashboardViewsByDate'

        });
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard views by date:', error);
        throw error;
    }
};

export const getDashboardViewsByName = async (userId) => {
    try {
        const response = await axios.post(`${apiBaseUrl}/getDashboardViewsByName`, {
            myUserId: userId,
            action: 'getDashboardViewsByName'
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard views by name:', error);
        throw error;
    }
};

export const getDashboardViewsByUser = async (userId) => {
    try {
        const response = await axios.post(`${apiBaseUrl}/getDashboardViewsByUser`, {
            myUserId: userId,
            action: 'getDashboardViewsByUser'
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard views by user:', error);
        throw error;
    }
};

export const getDashboardViewsByInstance = async (userId) => {
    try {
        const response = await axios.post(`${apiBaseUrl}/getDashboardViewsByInstance`, {
            myUserId: userId,
            action: 'getDashboardViewsByInstance'
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard views by instance:', error);
        throw error;
    }
};

export const addUserDashboard = async (folderId, dashboardId) => {
    try {
        const { myUserId } = getGlobalState();
        if (typeof dashboardId == 'string') {
            if (dashboardId.startsWith('d_')) {
                dashboardId = dashboardId.substring(2);
            }
        }
        if (typeof folderId == 'string') {
            if (folderId.startsWith('f_')) {
                folderId = folderId.substring(2);
            }
        }
        await axios.post(`${apiBaseUrl}/addUserDashboard/`, {
            myUserId: myUserId,
            runningUserId: myUserId,
            action: 'addUserDashboard',
            folderId: folderId,
            dashboardId: dashboardId
        });
    } catch (error) {
        console.error('Error adding user dashboard:', error);
        throw error;
    }
};

export const addAllDashboard = async (folderId, dashboardId) => {
    try {
        const { myUserId } = getGlobalState();
        if (typeof dashboardId == 'string') {
            if (dashboardId.startsWith('d_')) {
                dashboardId = dashboardId.substring(2);
            }
        }
        if (typeof folderId == 'string') {
            if (folderId.startsWith('f_')) {
                folderId = folderId.substring(2);
            }
        }
        const response = await axios.post(`${apiBaseUrl}/addUserDashboard/`, {
            myUserId: 2,
            runningUserId: myUserId,
            action: 'addAllDashboard',
            folderId: folderId,
            dashboardId: dashboardId
        });
        console.log('setDashboardPublished response:', response.data);
        const values = {
            DASHBOARD_NAME: response.data.dashboard_name
        };
        return await contactDashboardOwners(dashboardId,
            config.messageDetails.setDashboardPublished.subject,
            fillTemplate(config.messageDetails.setDashboardPublished.body, values));
    } catch (error) {
        console.error('Error adding user dashboard:', error);
        throw error;
    }
};

export const moveUserDashboard = async (folderId, dashboardId, oldFolderId) => {
    try {
        const { myUserId } = getGlobalState();
        // Remove the 'd_' prefix from dashboardId
        const dashboardIdWithoutPrefix = dashboardId.startsWith('d_') ? dashboardId.substring(2) : dashboardId;
        // Remove the 'f_' prefix from folderId and oldFolderId
        const folderIdWithoutPrefix = folderId.startsWith('f_') ? folderId.substring(2) : folderId;
        const oldFolderIdWithoutPrefix = oldFolderId.startsWith('f_') ? oldFolderId.substring(2) : oldFolderId;

        const response = await axios.post(`${apiBaseUrl}/moveUserDashboard/`, {
            myUserId: myUserId,
            folderId: folderIdWithoutPrefix,
            dashboardId: dashboardIdWithoutPrefix,
            oldFolderId: oldFolderIdWithoutPrefix,
            action: 'moveUserDashboard'
        });
        console.log('moveUserDashboard response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error moving user dashboard:', error);
        throw error;
    }
};

export const addUserFolder = async (parentId, folderName) => {
    try {
        const { myUserId } = getGlobalState();

        if (typeof parentId == 'string') {
            if (parentId.startsWith('f_')) {
                parentId = parentId.substring(2);
            }
        }
        const response = await axios.post(`${apiBaseUrl}/addMyTreeFolder/`, {
            myUserId: myUserId,
            parentFolder: parentId,
            folderName: folderName,
            action: 'addUserFolder'
        });
        return response.data;
    } catch (error) {
        console.error('Error adding folder:', error);
        throw error;
    }
};

// Helper function to wait for myUserId
const waitForMyUserId = async () => {
    while (!getGlobalState().myUserId) {
        await new Promise(resolve => setTimeout(resolve, 100));
    }
};

export const getDashboardDetails = async (dashboardId) => {
    await waitForMyUserId();
    const { myUserId } = getGlobalState();
    try {
        const response = await axios.post(`${apiBaseUrl}/getDashboardDetails`, {
            myUserId: myUserId,
            action: 'getDashboardDetails',
            dashboardId: processOutgoing(dashboardId)
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard details:', error);
        throw error;
    }
};

export const getDashboardRedirectTargets = async () => {
    const { myUserId } = getGlobalState();
    try {
        const response = await axios.post(`${apiBaseUrl}/getDashboardRedirectTargets`, {
            myUserId: myUserId,
            action: 'getDashboardRedirectTargets'
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard redirect targets:', error);
        throw error;
    }
};

export const getDashboardRedirectTypes = async () => {
    const { myUserId } = getGlobalState();
    try {
        const response = await axios.post(`${apiBaseUrl}/getDashboardRedirectTypes`, {
            myUserId: myUserId,
            action: 'getDashboardRedirectTypes'
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard redirect targets:', error);
        throw error;
    }
};

export const insertDashboardRedirect = async (dashboardId, targetDashboadId, redirectType) => {
    const { myUserId } = getGlobalState();
    try {
        const response = await axios.post(`${apiBaseUrl}/insertDashboardRedirect`, {
            myUserId: myUserId,
            dashboardId: dashboardId,
            action: 'insertDashboardRedirect',
            targetDashboardId: targetDashboadId,
            redirectType: redirectType
        });
        const values = {
            DASHBOARD_NAME: response.data.dashboard_name,
            TARGET_DASHBOARD_NAME: response.data.target_dashboard_name,
            REDIRECT_TYPE: response.data.redirect_type,
            REDIRECT_DESCRIPTION: response.data.redirect_description
        };
        return await contactDashboardOwners(dashboardId,
            config.messageDetails.insertDashboardRedirect.subject,
            fillTemplate(config.messageDetails.insertDashboardRedirect.body, values));
    } catch (error) {
        console.error('Error updating owners list:', error);
        throw error;
    }
};

export const getDashboardOwnersList = async (dashboardId) => {
    const { myUserId } = getGlobalState();
    try {
        const response = await axios.post(`${apiBaseUrl}/getDashboardOwnersList`, {
            myUserId: myUserId,
            action: 'getDashboardOwnersList',
            dashboardId: processOutgoing(dashboardId)
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching owner details:', error);
        throw error;
    }
};

export const updateDashboardOwners = async (dashboardId, ownersList) => {
    const { myUserId } = getGlobalState();
    try {
        const response = await axios.post(`${apiBaseUrl}/updateDashboardOwners`, {
            myUserId: myUserId,
            dashboardId: dashboardId,
            action: 'updateDashboardOwners',
            ownersList: ownersList
        });
        return response.data;
    } catch (error) {
        console.error('Error updating owners list:', error);
        throw error;
    }
};

export const addDashboardError = async (userId, dashboardId, errorText) => {
    try {
        const response = await axios.post(`${apiBaseUrl}/addDashboardError`, {
            myUserId: userId,
            dashboardId,
            errorText,
            action: 'addDashboardError'
        });
        const values = {
            USER_FULL_NAME: response.data.user_full_name,
            DASHBOARD_NAME: response.data.dashboard_name,
            ERROR_TEXT: response.data.errorText
        };
        const contactResponse = await contactDashboardOwners(dashboardId,
            config.messageDetails.addDashboardError.subject,
            fillTemplate(config.messageDetails.addDashboardError.body, values));
        console.log('contactResponse:', contactResponse);
        return response.data;
    } catch (error) {
        console.error('Error adding dashboard error:', error);
        throw error;
    }
};

export const addAccessRequest = async (userId, dashboardId) => {
    try {
        const response = await axios.post(`${apiBaseUrl}/addAccessRequest`, {
            myUserId: userId,
            dashboardId,
            action: 'addAccessRequest'
        });
        const values = {
            USER_FULL_NAME: response.data[0].user_full_name,
            DASHBOARD_NAME: response.data[0].dashboard_name
        };
        return await contactDashboardOwners(dashboardId,
            config.messageDetails.addAccessRequest.subject,
            fillTemplate(config.messageDetails.addAccessRequest.body, values));
    } catch (error) {
        console.error('Error adding dashboard error:', error);
        throw error;
    }
};

export const getAccessRequests = async (userId) => {
    const { myUserId } = getGlobalState();
    try {
        const response = await axios.post(`${apiBaseUrl}/getAccessRequests`, {
            userId: userId,
            runningUserId: myUserId,
            action: 'getAccessRequests'
        });
        return response.data;
    } catch (error) {
        console.error('Error adding dashboard error:', error);
        throw error;
    }
};

export const approveDenyAccessRequest = async (requestId, decision) => {
    const { myUserId } = getGlobalState();
    try {
        const response = await axios.post(`${apiBaseUrl}/approveDenyAccessRequest`, {
            myUserId,
            requestId,
            action: 'approveDenyAccessRequest',
            decision
        });
        console.log('approveDenyAccessRequest response:', response.data);
        console.log('approveDenyAccessRequest type:', typeof response.data);
        const values = {
            USER_FULL_NAME: response.data.user_full_name,
            DASHBOARD_NAME: response.data.dashboard_name,
            REQUEST_STATUS: decision.toLowerCase()
        };
        const contactResponse = await sendSingleMessage(response.data.requester_user_id,
            config.messageDetails.approveDenyAccessRequest.subject,
            fillTemplate(config.messageDetails.approveDenyAccessRequest.body, values));
        console.log('contactResponse:', contactResponse);
        return contactResponse.data;
    } catch (error) {
        console.error('Error approving | or denying access request:', error);
        throw error;
    }
};

export const setDashboardPendingPublishing = async (dashboardId) => {
    const { myUserId } = getGlobalState();
    const response = await axios.post(`${config.apiBaseUrl}/setDashboardPendingPublishing`, {
        myUserId: myUserId,
        action: 'setDashboardPendingPublishing',
        dashboardId,
    });
    console.log('setDashboardUnPublishing response:', response.data);
    const values = {
        DASHBOARD_NAME: response.data.dashboard_name
    };
    return await contactDashboardOwners(dashboardId,
        config.messageDetails.setDashboardPendingPublishing.subject,
        fillTemplate(config.messageDetails.setDashboardPendingPublishing.body, values));
};

export const setDashboardUnPublishing = async (dashboardId) => {
    const { myUserId } = getGlobalState();
    const response = await axios.post(`${config.apiBaseUrl}/setDashboardUnPublishing`, {
        myUserId: myUserId,
        action: 'setDashboardUnPublishing',
        dashboardId,
    });
    console.log('setDashboardUnPublishing response:', response.data);
    const values = {
        DASHBOARD_NAME: response.data.dashboard_name
    };
    return await contactDashboardOwners(dashboardId,
        config.messageDetails.setDashboardUnPublishing.subject,
        fillTemplate(config.messageDetails.setDashboardUnPublishing.body, values));
};

export const getDashboardAdmin = async (userId) => {
    const { myUserId } = getGlobalState();
    const response = await axios.post(`${config.apiBaseUrl}/getDashboardAdmin`, {
        userId: userId,
        runningUserId: myUserId,
        action: 'getDashboardAdmin'
    });
    return response.data;
};

export const getDashboardOverview = async (userId) => {
    const { myUserId } = getGlobalState();
    const response = await axios.post(`${config.apiBaseUrl}/getDashboardOverview`, {
        userId: userId,
        runningUserId: myUserId,
        action: 'getDashboardOverview'
    });
    return response.data;
};

export const sendSingleMessage = async (targetUserId, subject, message) => {
    const { myUserId } = getGlobalState();
    const safeSubject = subject ?? "";
    const response = await axios.post(`${config.apiBaseUrl}/sendSingleMessage`, {
        myUserId: myUserId,
        targetUserId: targetUserId,
        action: 'sendSingleMessage',
        channel: config.defaultChannel,
        responseAddress: config.responseAddress,
        subject: safeSubject,
        message: message
    });
    return response.data;
};

export const contactDashboardOwners = async (dashboardId, subject, message) => {
    const { myUserId } = getGlobalState();
    const safeSubject = subject ?? "";
    const response = await axios.post(`${config.apiBaseUrl}/contactDashboardOwners`, {
        myUserId: myUserId,
        dashboardId: dashboardId,
        action: 'contactDashboardOwners',
        channel: config.defaultChannel,
        responseAddress: config.responseAddress,
        subject: safeSubject,
        message: message
    });
    return response.data;
};